<template>
  <el-container>
    <el-header height="54px" style="padding: 0 10px">
      <el-row>
        <el-col :span="2">
          <el-radio-group v-model="formData.isOnSale" @input="handleSearch">
            <el-radio-button label="0">在售</el-radio-button>
            <el-radio-button label="1">下架</el-radio-button>
          </el-radio-group>
        </el-col>
        <el-col :span="11">
          <el-form :inline="true" :model="formData">
            <el-form-item label="货号">
              <el-input v-model="formData.itemNo" clearable placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="供应商">
              <el-input v-model="formData.supplierName" clearable placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="是否已配置供应商">
              <el-select v-model="formData.isSupplier" placeholder="请选择是否已配置供应商" style="width: 125px" clearable>
                <el-option v-for="item in isSupplierOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="11" class="operate">
          <el-button type="primary" plain icon="el-icon-plus" @click="handleAddNew">新增</el-button>
          <el-button type="danger" plain icon="el-icon-delete" @click="handleDelete(null)">删除</el-button>
          <el-button plain :icon="formData.isOnSale == 0 ? 'el-icon-sort-down' : 'el-icon-sort-up'" @click="handleMultiState">
            {{ formData.isOnSale == 0 ? '下架' : '上架' }}
          </el-button>
          <el-button plain icon="el-icon-upload2" @click="handleImport">导入</el-button>
          <el-button plain icon="el-icon-download" :loading="loading" @click="handleExport">导出</el-button>
          <el-button type="primary" plain icon="el-icon-connection" @click="handleSynPlatform">同步设置</el-button>
          <el-button icon="el-icon-plus" @click="handleSetSupplier">配置默认供应商</el-button>
          <el-button type="primary" plain icon="el-icon-printer" @click="handleBatchPrintBarcode">批量打印条码</el-button>
        </el-col>
      </el-row>
    </el-header>
    <el-main>
      <el-table
        stripe
        border
        ref="productTable"
        row-key="ProductID"
        :data="tableData.items"
        @selection-change="handleSelectionChange"
        v-loading="tableData.loading"
        :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
        height="100%"
      >
        <el-table-column type="selection" width="39" />
        <el-table-column prop="ItemNo" label="货号" width="200" fixed>
          <template slot-scope="{ row }">
            {{ row.ItemNo }}
            <span class="el-icon-edit-outline" v-if="row.ItemNo != ''" style="cursor: pointer" @click="handleDialogShow(row, 'item')" />
          </template>
        </el-table-column>
        <el-table-column prop="Colors" label="颜色">
          <template slot-scope="{ row }">
            {{ row.Colors }}
            <span class="el-icon-edit-outline" v-if="row.Colors != ''" style="cursor: pointer" @click="handleDialogShow(row, 'color')" />
          </template>
        </el-table-column>
        <el-table-column prop="Sizes" label="尺码" />
        <el-table-column prop="DefaultSupplierName" label="供应商" />
        <el-table-column prop="Price" label="商品价">
          <template slot-scope="{ row }">
            {{ $store.state.routes.systemSetting.IsHideProductPriceAuth ? '**' : row.Price }}
            <span class="el-icon-edit-outline" style="cursor: pointer" @click="handleDialogShow(row, 'item')" />
          </template>
        </el-table-column>
        <el-table-column prop="Cost" label="采购价">
          <template slot-scope="{ row }">
            {{ $store.state.routes.systemSetting.IsHideCostPriceAuth ? '**' : row.Cost }}
            <span class="el-icon-edit-outline" style="cursor: pointer" @click="handleDialogShow(row, 'item')" />
          </template>
        </el-table-column>
        <el-table-column prop="Shelves" label="货架" />
        <el-table-column prop="Memo" label="备注" />
        <el-table-column label="状态" width="80" align="center" header-align="center">
          <template slot-scope="scope">{{ scope.row.IsOnSale == 0 ? '在售' : '下架' }}</template>
        </el-table-column>
        <el-table-column label="操作" width="320" align="center" header-align="center">
          <template slot-scope="scope">
            <el-button type="primary" plain size="mini" @click="handleEdit(scope.row)" v-if="scope.row.IsOnSale == 0">编辑</el-button>
            <el-button plain size="mini" @click="handlePrintBarcode(scope.row)">打印条码</el-button>
            <el-button plain size="mini" @click="handleState(scope.row)"> {{ scope.row.IsOnSale == 0 ? '下架' : '上架' }}</el-button>
            <el-button type="danger" plain size="mini" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-footer height="45px">
      <el-pagination
        background
        :total="tableData.total"
        :page-size="tableData.pageSize"
        :current-page="tableData.currentPage"
        :page-sizes="[10, 15, 20, 30, 50]"
        layout="prev, pager, next,total, sizes"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-footer>
    <product-import ref="ProductImport" @handleSearch="handleSearch" />
    <product-edit-simple ref="productEditSimple" @handleSearch="handleSearch" />
    <product-setting ref="productSettingDlg" @handleSearch="handleSearch" />
    <syn-platform-setting ref="synPlatformSettingDlg" />
    <helper-center ref="helperCenter" position="product" :visible="true"></helper-center>
    <comfirm-del
      ref="comfirmDelDlg"
      :productIDs="delProductIDs"
      :confimMsg="delProductConfimMsg"
      @handleRefresh="fetchData"
      @handleDrawer="toDrawer"
    />
    <el-drawer ref="drawer" :visible="drawerVisible" title="处理商品提货" size="90%" :direction="direction" :before-close="handleClose">
      <component :is="currentComponent" :productIds="delProductIDs"></component>
    </el-drawer>
    <el-dialog :visible="supplierData.visible" title="批量配置默认供应商" @close="handleCancel" :close-on-click-modal="false" width="600px">
      <div v-loading="supplierData.loading">
        <el-form ref="editSupplierForm" :model="supplierData">
          <el-form-item label="商品货号：">
            {{ supplierData.productNames }}
          </el-form-item>
          <el-form-item label="供应商：">
            <el-autocomplete
              placeholder="供应商"
              v-model="supplierData.supplierName"
              style="width: 150px"
              :fetch-suggestions="loadSuppliers"
            />
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="handleSaveSuppliers" v-loading="supplierData.loading">确 定</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>
<script>
import { submit, exportFile } from '@/api/base'
import { requestData } from '@/api/quote'

import ProductImport from './components/Import.vue'
import ProductEditSimple from './components/Edit.vue'
import ProductSetting from './components/ProductSetting.vue'
import SynPlatformSetting from './components/SynPlatformSetting.vue'
import HelperCenter from '@/views/stall/trade/components/HelperCenter.vue'
import ComfirmDel from './components/ComfirmDel.vue'
import ComponentA from '../../stall/trade/cashier/index.vue'

export default {
  name: 'productSimple',
  components: {
    ProductImport,
    ProductEditSimple,
    ProductSetting,
    SynPlatformSetting,
    HelperCenter,
    ComfirmDel,
    ComponentA,
  },
  data() {
    return {
      drawerVisible: false,
      currentComponent: 'ComponentA',
      direction: 'rtl',
      loading: false,
      selectRows: [],
      formData: {
        itemNo: '',
        supplierName: '',
        isOnSale: 0,
      },
      tableData: {
        loading: false,
        items: [],
        total: 0,
        pageSize: 15,
        currentPage: 1,
      },
      delProductIDs: '',
      delProductConfimMsg: '',
      supplierData: {
        loading: false,
        visible: false,
        productNames: '',
        productIds: '',
        supplierName: '',
        suppliers: [],
      },
      isSupplierOptions: [
        { value: 0, label: '否' },
        { value: 1, label: '是' },
      ],
    }
  },
  mounted() {
    const _this = this
    _this.$nextTick(async () => {
      await _this.fetchData()
    })
    _this.fetchSuppliers()
  },
  methods: {
    handleClose() {
      this.drawerVisible = false
    },
    // loadComponent() {
    //     const ComponentClass = Vue.extend(ComponentA)
    //     const instance = new ComponentClass({
    //         propsData: { someProp: 'value' }
    //     }).$mount()

    //     // 将组件插入到Drawer内容区域
    //     this.$refs.drawerContent.appendChild(instance.$el)
    // },
    //选项发生改变
    handleSelectionChange(selection) {
      this.selectRows = selection
    },
    async fetchData() {
      const _this = this

      _this.tableData.loading = true
      const { data } = await submit('/api/product/getList', {
        PageSize: _this.tableData.pageSize,
        CurrentPage: _this.tableData.currentPage,
        ItemNo: _this.formData.itemNo,
        SupplierName: _this.formData.supplierName,
        IsOnSale: _this.formData.isOnSale,
        IncludeColorsAndSizes: true,
        IsSupplier: _this.formData.isSupplier,
      }).finally(() => {
        _this.tableData.loading = false
      })

      _this.tableData.total = data.total
      _this.tableData.items = data.datas
    },
    handleSearch() {
      this.fetchData()
    },
    handleAddNew() {
      let postData = {
        ItemNo: '',
        ProductID: 0,
        IncludeSettle: false,
        Type: 'item',
      }
      this.$refs.productSettingDlg.open(postData)
    },
    handleEdit(row) {
      let postData = {
        ItemNo: row.ItemNo,
        ProductID: row.ProductID,
        IncludeSettle: false,
        Type: 'item',
      }
      this.$refs.productSettingDlg.open(postData)
    },
    //页面弹窗操作
    handleDialogShow(row, type) {
      let postData = {
        ItemNo: row.ItemNo,
        ProductID: row.ProductID,
        IncludeSettle: false,
        Type: type,
      }
      this.$refs.productSettingDlg.open(postData)
    },
    //批量下架
    handleMultiState() {
      var that = this
      const action = parseInt(that.formData.isOnSale) == 0 ? '下架' : '上架'
      if (that.selectRows.length <= 0) {
        that.$baseMessage(`请选择要${action}的记录`, 'error')
        return
      }
      let ids = that.selectRows.map(x => x.ProductID)
      this.$confirm(`您是否要${action}选中的 ${that.selectRows.length} 条记录?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const result = await submit('/api/product/changeOnSale', {
          ProductIDs: ids.join(','),
          IsOnSale: parseInt(that.formData.isOnSale) === 0 ? 1 : 0,
        })
        if (result.success) {
          this.$message({
            type: 'success',
            message: `${action}成功!`,
          })
          that.fetchData()
        }
      })
    },
    handleState(row) {
      const action = row.IsOnSale === 0 ? '下架' : '上架'
      this.$confirm(`您是否要${action}货品：${row.ItemNo} ?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const result = await submit('/api/product/changeOnSale', {
          ProductIDs: row.ProductID,
          IsOnSale: row.IsOnSale === 0 ? 1 : 0,
        })
        if (result.success) {
          this.$message({
            type: 'success',
            message: `${action}成功!`,
          })
          this.fetchData()
        }
      })
    },
    handleDelete(row) {
      var that = this
      if (row == null) {
        if (that.selectRows.length <= 0) {
          that.$baseMessage('请选择要删除的记录', 'error')
          return
        }
        that.$baseConfirm(`您是否要删除选中的 ${that.selectRows.length} 条记录?`, '提示', async () => {
          let ids = that.selectRows.map(x => x.ProductID)
          that.delProductIDs = ids.join(',')
          that.handleExecute()
        })
      } else {
        that.$baseConfirm(`您是否要删除货品：${row.ItemNo} ?`, '提示', async () => {
          that.delProductIDs = row.ProductID
          that.handleExecute()
        })
      }
    },
    toDrawer() {
      var that = this
      sessionStorage.setItem('productIDs', that.delProductIDs)
      console.log('传到子组件数据:', that.delProductIDs)
      that.drawerVisible = true
    },
    async handleExecute() {
      var that = this
      await requestData('/api/product/Delete', {
        ProductIDs: that.delProductIDs,
      }).then(res => {
        if (res.success) {
          that.$message({
            type: 'success',
            message: '删除成功!',
          })
          that.fetchData()
        } else {
          that.$refs.comfirmDelDlg.open(res.msg, that.delProductIDs)
        }
      })
    },
    handleSynPlatform() {
      this.$refs.synPlatformSettingDlg.open()
    },
    handleImport() {
      const _this = this
      _this.$nextTick(() => {
        _this.$refs.ProductImport.initDialog()
      })
    },
    async handleExport() {
      const selection = JSON.parse(JSON.stringify(this.$refs.productTable.selection))

      this.loading = true
      const { data } = await exportFile('/api/product/exportEx', {
        ProductIDs: selection
          .map(p => {
            return p.ProductID
          })
          .join(','),
        IsOnSale: this.formData.isOnSale,
        IsSupplier: this.formData.isSupplier,
      }).finally(() => {
        this.loading = false
      })

      const blob = new Blob([data.Blob], { type: 'application/vnd.ms-excel' })
      var a = document.createElement('a')
      a.href = URL.createObjectURL(blob)
      a.download = data.FileName
      a.style.display = 'none'
      document.body.appendChild(a)
      a.click()
      a.remove()
    },
    handleSizeChange(size) {
      this.tableData.pageSize = size
      this.fetchData()
    },
    handleCurrentChange(page) {
      this.tableData.currentPage = page
      this.fetchData()
    },
    async fetchSuppliers() {
      const { data } = await submit('/api/purchase/supplier/getList', {
        CurrentPage: 1,
        PageSize: 1000,
      })
      data.datas.forEach(element => {
        element.value = element.SupplierName
      })
      this.supplierData.suppliers = data.datas || []
    },
    async loadSuppliers(qs, cb) {
      const suppliers = this.supplierData.suppliers
      var results = qs ? suppliers.filter(this.createFilter(qs)) : suppliers
      cb(results || [])
    },

    createFilter(qs) {
      return supplier => {
        return supplier.value.toLowerCase().includes(qs.toLowerCase())
      }
    },
    handleSetSupplier() {
      var that = this
      if (that.selectRows.length <= 0) {
        that.$baseMessage('请选择要配置默认供应商的记录', 'error')
        return
      }
      that.supplierData.productIds = that.selectRows.map(x => x.ProductID).join(',')
      that.supplierData.productNames = that.selectRows.map(x => x.PName).join(',')

      that.supplierData.visible = true
    },
    handlePrintBarcode(row) {
      const url = this.$router.resolve({
        path: '/product/barcode-print',
        query: { productID: row.ProductID },
      }).href
      window.open(url, '_blank')
    },
    handleBatchPrintBarcode() {
      var that = this
      if (that.selectRows.length <= 0) {
        that.$baseMessage('请选择要打印条码的商品', 'error')
        return
      }
      const productIDs = that.selectRows.map(x => x.ProductID).join(',')
      const url = that.$router.resolve({
        path: '/product/barcode-print',
        query: { productIDs },
      }).href
      window.open(url, '_blank')
    },
    handleCancel() {
      this.supplierData.visible = false
    },
    async handleSaveSuppliers() {
      var that = this
      that.supplierData.loading = true
      const result = await submit('/api/product/ChangeSuppliers', {
        ProductIds: that.supplierData.productIds,
        SupplierName: that.supplierData.supplierName,
      }).finally(() => {
        that.supplierData.loading = false
      })
      that.supplierData.loading = false
      if (result.success) {
        that.supplierData.visible = false
        that.$message({
          type: 'success',
          message: '配置默认供应商成功!',
        })
        that.fetchData()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.el-header {
  ::v-deep {
    .el-row {
      display: flex;
      align-items: center;
      height: 100%;
    }

    .el-radio-button__inner {
      height: 33px !important;
    }

    .el-form-item {
      margin-bottom: 0 !important;
    }

    .el-input {
      width: 130px !important;
    }

    .el-button {
      height: 33px !important;
    }

    .operate {
      text-align: right;
    }
  }
}
</style>
